import gql from 'graphql-tag';

export default gql`
  mutation addTravelPlan($input: addTravelPlanInput!) {
    addTravelPlan(input: $input) {
      viewer {
        id
        repVisitsTravelPlan {
          id
          name
        }
      }
    }
  }
`;
